import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ToastContext } from "../../../App";
import {useMobile} from '../../../hooks/useMobile'
import {
  foodStationApi,
  useGetStationListQuery,
} from "../../../redux/services/foodStation";
import { useLazyGetScheduleSlotsByDateQuery } from "../../../redux/services/schedule";
import { setLoading } from "../../../redux/slices/app.slice";
import { formatDates, formatSlot } from "../../../utils/charts";
import getSubdomain from "../../../utils/getSubdomain";
import StationsStatistics from "./Statistic/StationsStatistics";
import StationStatistics from "./Statistic/StationStatistics";
import * as styles from "./Statistics.module.css";

const Statistics = () => {
	const showToast = useContext(ToastContext);
	const [stationsList, setStationsList] = useState([{value: 'all-stations',  label: 'All Stations'}])
	const [slotsList, setSlotsList] = useState([{value: 'all-slots',  label: 'All Slots'}])
	const [selectedStation, setSelectedStation] = useState('all-stations')
	const [selectedStationName, setSelectedStationName] = useState('')
	const [selectedDates, setSelectedDates] = useState([new Date()])
	const [selectedSlots, setSelectedSlots] = useState('all-slots')
	const dispatch = useDispatch();
	useMobile(768);
	
	const { data: stationsData, isSuccess: isStationsSuccess, isLoading: isStationsLoading, isError: isStationsError } = useGetStationListQuery(getSubdomain())
	const [fetchSlots, { data: slotsData, isSuccess: isSlotsSuccess, isLoading: isSlotsLoading, isError: isSlotsDataError }] = useLazyGetScheduleSlotsByDateQuery()
	
	useEffect(() => {
		if(isStationsSuccess) {
			const options = stationsList
			for (const station of stationsData) {
				options.push({value: station.id,  label: station.name})
			}
			setStationsList(options)
			dispatch(setLoading(false));
		}
	}, [isStationsSuccess])
	
	useEffect(() => {
		if(isSlotsSuccess) {
			const options = [{value: 'all-slots',  label: 'All Slots'}]
			for (const slot of slotsData) {
				options.push({value: slot.slot_id,  label: formatSlot(slot)})
			}
			setSlotsList(options)
			dispatch(setLoading(false));
		}
	}, [isSlotsSuccess, slotsData])
	
	useEffect(() => {
		if(isStationsError)
			showToast("error", "Station", "Unable to load stations")
	}, [isStationsError])
	
	useEffect(()=>{
		if(isSlotsDataError)
			showToast("error", "Slots", "Unable to load slots")
	}, [isSlotsDataError])
	
	useEffect(()=> {
		if(selectedStation === 'all-stations')
			foodStationApi.util.invalidateTags(['StationsStatistic'])
		else {
			fetchSlots({
				subdomain: getSubdomain(),
				date: formatDates(selectedDates),
				id: selectedStation
			})
			foodStationApi.util.invalidateTags(['StationStatistic'])
		}
	}, [selectedDates, selectedStation, selectedSlots])
	
	useEffect(() => {
		setSelectedSlots('all-slots')
	}, [selectedStation])
	
	return (
		<div className={styles.pageWrapper}>
			<div className={styles.header}>
				<h2>Statistic</h2>
				<Button
					label="PRINT TO PDF"
					icon="pi pi-download"
					className={styles.downloadBtn}
				/>
			</div>
			
			<div className={styles.block}>
				<Dropdown
					disabled={!isStationsSuccess}
					loading={isStationsLoading}
					value={selectedStation}
					onChange={e => {
						setSelectedStation(e.value)
						setSelectedStationName(stationsList.find(st=> st.value === e.value).label)
					}}
					options={stationsList}
					placeholder="Select a station"
					className={styles.dropdown}
					filter
				/>
				<Calendar
					value={selectedDates}
					onChange={(e) => setSelectedDates(e.value)}
					className={styles.datepicker}
					dateFormat="dd/mm/yy"
					selectionMode="range"
				/>
				<Dropdown
					placeholder="Select TimeSlot"
					className={styles.dropdown}
					disabled={selectedStation === 'all-stations'}
					loading={isSlotsLoading}
					value={selectedSlots}
					onChange={e =>
						setSelectedSlots(e.value)
					}
					options={slotsList}
				/>
			</div>
			
			<div className={styles.divider} />
			
			{ selectedStation === 'all-stations'
				? (<StationsStatistics selectedDates={selectedDates}/>)
				: (<StationStatistics selectedDates={selectedDates} selectedSlot={selectedSlots} selectedStation={selectedStation} slotsData={slotsData} stationName={selectedStationName} />) }
		</div>
	)
}

export default Statistics;
